import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";

export const getReferralCode = createServerFn({ method: "GET" }).handler(() => {
	const codeCookie = getCookie("REFERRAL_CODE");

	return codeCookie;
});
